var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg33Together({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.40942,
    cy: 10.8177,
    rx: 1.56944,
    ry: 1.55524,
    fill: "inherit"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.73691,
    cy: 13.6594,
    rx: 1.56944,
    ry: 1.55524,
    fill: "inherit"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.24904,
    cy: 16.3042,
    rx: 1.56944,
    ry: 1.55524,
    fill: "inherit"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.55596,
    ry: 1.56873,
    transform: "matrix(-0.207912 -0.978148 0.978963 -0.204037 14.6072 3.98819)",
    fill: "inherit"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.55612,
    ry: 1.56858,
    transform: "matrix(-0.207912 -0.978148 0.979044 -0.203648 12.748 6.9672)",
    fill: "inherit"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.55588,
    ry: 1.56881,
    transform: "matrix(-0.207912 -0.978148 0.978921 -0.204241 10.8888 10.0122)",
    fill: "inherit"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 7.43736,
    width: 7.97467,
    height: 1.46504,
    rx: 0.73252,
    fill: "inherit"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 18.4164,
    width: 11.8608,
    height: 1.46504,
    rx: 0.73252,
    fill: "inherit"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 19.8815,
    width: 12.2664,
    height: 1.46504,
    rx: 0.73252,
    transform: "rotate(-90 0 19.8815)",
    fill: "inherit"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 11.9711,
    height: 1.46504,
    rx: 0.73252,
    transform: "matrix(-0.207912 -0.978148 0.97896 -0.204052 8.15373 14.2984)",
    fill: "inherit"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12.1403,
    height: 1.46621,
    rx: 0.733105,
    transform: "matrix(-0.207912 -0.978148 0.97896 -0.204052 18.3103 12.0582)",
    fill: "inherit"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 11.614,
    height: 1.46504,
    rx: 0.73252,
    transform: "matrix(0.975142 -0.221579 0.225438 0.974257 7.97467 12.946)",
    fill: "inherit"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11.6304,
    height: 1.46504,
    rx: 0.732519,
    transform: "matrix(0.97309 -0.230424 0.23442 0.972135 5.73689 2.56398)",
    fill: "inherit"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.15764,
    height: 1.46504,
    rx: 0.73252,
    transform: "matrix(-0.00144208 0.999999 -0.999999 -0.00141611 11.8705 12.7264)",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg33Together);
export default __webpack_public_path__ + "static/media/33-together.5603f7e85c485089bd8f44f1aa17ef4f.svg";
export { ForwardRef as ReactComponent };